export default __webpack_public_path__ + "394fc7675cbf02972d60201f822f6a8f.png";